import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { AlertService ,ResourceService} from 'sce-core';
import { UserService } from '../../core/security/user.service';
import { PrintLookupComponent } from '../lookup/print-lookup/print-lookup.component';
import { ModalService } from './modal.service';
import { SearchableEntityDataService } from './searchable-entity/searchable-entity-data.service';
import { SearchService } from '../search/search.service';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class PrinterService {

  protected hasAdditionalFields: boolean = false;
  public printerId: any;
  public parentDataService: SearchableEntityDataService;
  public tableSearchServiceForWaveControl: SearchService;
  public printReportSubscribtion: Subscription;
  public moveKey;
  public isJREPORTcalled:boolean = false;
  public data: any;

  constructor(protected http$: HttpClient,
    protected alertService: AlertService,
    protected modalService: ModalService,
    protected resourceService: ResourceService,
    protected userService: UserService) { }

  /* [LFWM-2027] - documnetType - tableid
  * storer - storerkey value from parent screen
  * facility - facility value from parent screen
  * dataService - dataService of parent screen
  * primaryDataMap - primaryDataMap from parent screen
  * tableSearchService - its a optional parameter - [for wave control screen - tableSearchService is passed from wave control
    screen because which has more than one detail search service and detail table.
  */
  public printReport(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any, tableSearchService?: any,moveKey?:any) {
    this.moveKey = moveKey;
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      'documentType': documentType,
      'storer': storer,
      'facility': facility,
    };
    this.getModuleReport(reportDefaultValues)
      .subscribe((resp: any) => {
        const dataToRemove: Array<string> = [
          'ExtendedParmDefault1',
          'ExtendedParmDefault2',
          'ExtendedParmDefault3',
          'ExtendedParmDefault4',
          'ExtendedParmDefault5',
          'ReportTitle',
          'NeedExtendedParm'];
        Object.keys(resp)
          .forEach((key: string) => {
            if (dataToRemove.indexOf(key) !== -1) {
              delete resp[key];
            }
          });
        tempList = <any[]>resp;
        if (this.userService.userInfo.defaultPrinter) {
          this.printerId = this.userService.userInfo.defaultPrinter;
          this.invokePrintModal(tempList, reportDefaultValues,
            this.printerId, primaryDataMap, false, null, 'DocReport', null);
        } else {
          this.userService.fetchDefaultPrinter()
            .subscribe((printeresp: any) => {
              this.printerId = printeresp;
              this.invokePrintModal(tempList, reportDefaultValues,
                this.printerId, primaryDataMap, false, null, 'DocReport', null);
            });
        }
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }

  public printFromViewReportScreen(reportConfig: any,
    rowDataMap: any, dataEditor: any, keyEventHandler: any) {
    if (this.userService.userInfo.defaultPrinter) {
      this.printerId = this.userService.userInfo.defaultPrinter;
      this.invokePrintModal(reportConfig, rowDataMap, this.printerId,
        rowDataMap, true, dataEditor, 'ViewReport', keyEventHandler);
    } else {
      this.userService.fetchDefaultPrinter()
        .subscribe((printeresp: any) => {
          this.printerId = printeresp;
          this.invokePrintModal(reportConfig, rowDataMap, this.printerId,
            rowDataMap, true, dataEditor, 'ViewReport', keyEventHandler);
        });
    }
  }

  public invokePrintModal(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any) {
    this.alertService.clearAll();
    // LFWM-2833 - Clearing the subscribtion
    if(this.printReportSubscribtion){
      this.printReportSubscribtion.unsubscribe();
    }
    const modalRef: any = this.modalService
      .showModal(PrintLookupComponent,
        {
          overlayHeader: this.resourceService.get('lbl_print_report'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    modalRef.content.setInitialData(reportConfig, inputValues,
      printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService,
      this.tableSearchServiceForWaveControl,this);
    if (source === 'ViewReport') {
      this.printReportSubscribtion = modalRef.content.printReportReceiveEvent()
        .subscribe((requestData: any) => {
          this.submitViewReportPrint(requestData)
            .subscribe((printeresp: any) => {
              if (printeresp.statusCode === 200) {
                const successMsg = this.resourceService.get('msg_prnt_succ');
                this.alertService.clearAll().success(successMsg);
                modalRef.hide();
              } else {
                this.alertService.clearAll().error(this.resourceService
                  .translateServerResponse(printeresp.statusMessage));
              }
            }, (err) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
            });
        });
    } else {
      this.printReportSubscribtion =  modalRef.content.printReportReceiveEvent()
        .subscribe((requestData: any) => {
          this.submitPrintReport(requestData)
            .subscribe((printeresp: any) => {
              if (printeresp.statusCode === 200) {
                const successMsg = this.resourceService.get('msg_prnt_succ');
                this.alertService.clearAll().success(successMsg);                
                let printResponse = printeresp.printresp[0];
                const printSource = requestData[0].printSource;
                const reportURL = printResponse.reportURL;
                // LFWM-5125
                // If reportURL is available, proceed with setting data and submitting the report
                if (reportURL) {
                  this.data = requestData[0];
                  this.data.iframeUrl = reportURL;
                  const reportId = this.data.reportID;
                  this.parentDataService.buttonService.submitJreport(reportId);
                }
                // printSource is 'JReport' but still  reportURL is null in payload, show error
                else if (!reportURL && printSource === 'JReport') {
                  this.alertService.clearAll().error(this.resourceService.get('jreport_url_not_available'));
                }
              
                modalRef.hide();
              } else {
                this.alertService.clearAll().error(this.resourceService.translateServerResponse(printeresp.statusMessage));
              }
            }, (err) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
            });
        });
    }
  }

  public getModuleReport(reportDefaultValues: any) {
    let reportType;
    if(reportDefaultValues.documentType == 'invmovetd'){
      reportType = 'PrintMoveLabel';
    }else{
      reportType = "";
    }
    const request = {
      'documentType': reportDefaultValues.documentType,
      'storerkey': reportDefaultValues.storer,
      'facility': reportDefaultValues.facility,
      'computerName': '',
      'printSource':'JREPORT',
      "reportType": reportType

    };
    const request1 = {
      'documentType': reportDefaultValues.documentType,
      'storerkey': reportDefaultValues.storer,
      'facility': reportDefaultValues.facility,
      'computerName': '',
      'printSource':'WMReport',
      "reportType": reportType

    };
    if (reportDefaultValues.documentType == 'invmovetd') {
      return this.getReport(request, reportDefaultValues,reportType);
    } else {
      const response$ = this.http$.post('api/report/module/report', JSON.stringify(request1))
        .map((response: any) => {
          return response;
        })
        .catch((error: any) => {
          if (error.error.length !== 0) {
            if (error.error.statusCode !== 200) {
              return Observable.throw(error.error.statusMessage);
            }
          }
        });
      return response$;
    }
  }

  getReport(request,reportDefaultValues,reportType){
    let response$;    
     response$ = this.http$.post('api/report/module/report', JSON.stringify(request))
      .map((response: any) => {
        if (response.reportDetailMapList) {
          this.isJREPORTcalled = true;
          return response;
        } else {
          const request1 = {
            'documentType': reportDefaultValues.documentType,
            'storerkey': reportDefaultValues.storer,
            'facility': reportDefaultValues.facility,
            'computerName': '',
            'printSource': 'WMReport',
            "reportType": reportType

          };
          return this.getWMReport(request1);
        }
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if(error.error.statusCode == 400){
            const request1 = {
              'documentType': reportDefaultValues.documentType,
              'storerkey': reportDefaultValues.storer,
              'facility': reportDefaultValues.facility,
              'computerName': '',
              'printSource': 'WMReport',
              "reportType": reportType
  
            };
            return this.getWMReport(request1);
          }
          // else if (error.error.statusCode !== 200 && error.error.statusCode !== 400) {
          //   return Observable.throw(error.error.statusMessage);
          // }
        }
      });
      return response$;
  }
  public getWMReport(request1){    
    const response$ = this.http$.post('api/report/module/report', JSON.stringify(request1))
    .map((response: any) => {
      this.isJREPORTcalled = false;
      return response;
    })
    .catch((error: any) => {
      if (error.error.length !== 0) {
        if (error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      }
    });
    return response$;
  }
  public submitPrintReport(printReportInput: any) {
    // LFWM-1811 : Print service url change    
    const response$ = this.http$.post('api/report/print', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400 && error.error.errors) {
            return Observable.throw(error.error.errors['0'].defaultMessage + ' - ' +
              error.error.errors['0'].rejectedValue);
          }
        }
      });
    return response$;
  }

  public getViewReportDetails(reportType: any) {
    const request = {
      'moduleID': 'ViewReport',
      'reportID': reportType.trim()
    };
    const response$ = this.http$.post('api/report/viewReport/params', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
  public submitViewReportPrint(printReportInput) {
    const response$ = this.http$.post('api/report/viewReport/print', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400 && error.error.errors) {
            return Observable.throw(error.error.errors['0'].defaultMessage + ' - ' +
              error.error.errors['0'].rejectedValue);
          }
        }
      });
    return response$;
  }
  // [LFWM-1980] - To fetch first and last line item number of records available in server side
  public getMinMaxOfLineItems(detailTableId: any, primayKey: any) {
    const url = 'api/asn/' + primayKey + '/' + detailTableId + '/minmax/lineitems';
    return this.http$.get(url)
        .map((response: any) => {
            return response;
        })
        .catch((error: any) => {
            if (error.error.length !== 0) {
                if (error.error.statusCode !== 200) {
                    return Observable.throw(error.error.statusMessage);
                }
            }
        });
  }

  // [LFWM-3396] Custom method for printing reports for selected mbolKeys from Ship Ref Search screen
  public printShipRefSearchReport(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any, selectedShipRefKeys: any, tableSearchService?: any) {
      this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      'documentType': documentType,
      'storer': storer,
      'facility': facility,
    };
    this.getModuleReport(reportDefaultValues)
      .subscribe((resp: any) => {
        const dataToRemove: Array<string> = [
          'ExtendedParmDefault1',
          'ExtendedParmDefault2',
          'ExtendedParmDefault3',
          'ExtendedParmDefault4',
          'ExtendedParmDefault5',
          'ReportTitle',
          'NeedExtendedParm'];
        Object.keys(resp)
          .forEach((key: string) => {
            if (dataToRemove.indexOf(key) !== -1) {
              delete resp[key];
            }
          });
        tempList = <any[]>resp;
        if (this.userService.userInfo.defaultPrinter) {
          this.printerId = this.userService.userInfo.defaultPrinter;
          this.invokeSearchPrintModal(tempList, reportDefaultValues,
            this.printerId, {}, false, null, 'DocReport', null, selectedShipRefKeys);

        } else {
          this.userService.fetchDefaultPrinter()
            .subscribe((printeresp: any) => {
              this.printerId = printeresp;
              this.invokeSearchPrintModal(tempList, reportDefaultValues,
                this.printerId, {}, false, null, 'DocReport', null, selectedShipRefKeys);
            });
        }
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }

  // [LFWM-3396] Custom method to invoke Print Model for Ship Ref Search screen
  public invokeSearchPrintModal(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any, selectedShipRefKeys: any) {
    this.alertService.clearAll();
    // LFWM-2833 - Clearing the subscribtion
    if (this.printReportSubscribtion) {
      this.printReportSubscribtion.unsubscribe();
    }
    const modalRef: any = this.modalService
      .showModal(PrintLookupComponent,
        {
          overlayHeader: this.resourceService.get('lbl_print_report'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    modalRef.content.setInitialData(reportConfig, inputValues,
      printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService,
      this.tableSearchServiceForWaveControl, this);
    this.printReportSubscribtion = modalRef.content.printReportReceiveEvent()
      .subscribe((requestData: any) => {
        requestData[0]['printParams'].forEach(function (param, i) {
          if (param['displayLabel'].toLowerCase() === ("mbolKey").toLowerCase()) {
            param['value'] = selectedShipRefKeys[i];
          }
        });
        this.submitPrintReport(requestData)
          .subscribe((printeresp: any) => {
            if (printeresp.statusCode === 200) {
              const successMsg = this.resourceService.get('msg_prnt_succ');
              this.alertService.clearAll().success(successMsg);
              modalRef.hide();
            } else {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(printeresp.statusMessage));
            }
          }, (err) => {
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
          });
      });
  }
  // LFWM-3191- made a new api /print/withPriv and /report/withPriv (replacement for print and report api) for kitting screen.
  //  to pass the privileges for checking the privileges at the backend level.
  public printReportForKitting(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any, privilege: any, tableSearchService?: any) {
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      'documentType': documentType,
      'storer': storer,
      'facility': facility,
    };
    this.getModuleReportForKitting(reportDefaultValues, privilege)
      .subscribe((resp: any) => {
        const dataToRemove: Array<string> = [
          'ExtendedParmDefault1',
          'ExtendedParmDefault2',
          'ExtendedParmDefault3',
          'ExtendedParmDefault4',
          'ExtendedParmDefault5',
          'ReportTitle',
          'NeedExtendedParm'];
        Object.keys(resp)
          .forEach((key: string) => {
            if (dataToRemove.indexOf(key) !== -1) {
              delete resp[key];
            }
          });
        tempList = <any[]>resp;
        if (this.userService.userInfo.defaultPrinter) {
          this.printerId = this.userService.userInfo.defaultPrinter;
          this.invokePrintModalForKitting(tempList, reportDefaultValues,
            this.printerId, primaryDataMap, false, null, 'DocReport', null, privilege);
        } else {
          this.userService.fetchDefaultPrinter()
            .subscribe((printeresp: any) => {
              this.printerId = printeresp;
              this.invokePrintModalForKitting(tempList, reportDefaultValues,
                this.printerId, primaryDataMap, false, null, 'DocReport', null, privilege);
            });
        }
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }
  // LFWM-3191- made a new api /print/withPriv and /report/withPriv  (replacement for print and report api) for kitting screen.
  //  to pass the privileges for checking the privileges at the backend level.
  public getModuleReportForKitting(reportDefaultValues: any, privilege: any) {
    const request = {
      'documentType': reportDefaultValues.documentType,
      'storerkey': reportDefaultValues.storer,
      'facility': reportDefaultValues.facility,
      'computerName': '',
      'printSource':'WMReport',
      'privilege': privilege
    };
    const response$ = this.http$.post('api/report/module/report/withPriv', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
  // LFWM-3191- made a new api /print/withPriv and /report/withPriv  (replacement for print and report api) for kitting screen.
  //  to pass the privileges for checking the privileges at the backend level.
  public submitPrintReportforKitting(printReportInput: any) {
    // LFWM-1811 : Print service url change
    const response$ = this.http$.post('api/report/print/withPriv', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400 && error.error.errors) {
            return Observable.throw(error.error.errors['0'].defaultMessage + ' - ' +
              error.error.errors['0'].rejectedValue);
          }
        }
      });
    return response$;
  }
  // LFWM-3191- made a new api /print/withPriv and /report/withPriv (replacement for print and report api) for kitting screen.
  //  to pass the privileges for checking the privileges at the backend level.
  public invokePrintModalForKitting(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any, privilege: any) {
    this.alertService.clearAll();
    let requestItem: any;
    // LFWM-2833 - Clearing the subscribtion
    if(this.printReportSubscribtion){
      this.printReportSubscribtion.unsubscribe();
    }
    const modalRef: any = this.modalService
      .showModal(PrintLookupComponent,
        {
          overlayHeader: this.resourceService.get('lbl_print_report'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    modalRef.content.setInitialData(reportConfig, inputValues,
      printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService,
      this.tableSearchServiceForWaveControl, this);
    if (source === 'ViewReport') {
      this.printReportSubscribtion = modalRef.content.printReportReceiveEvent()
        .subscribe((requestData: any) => {
          this.submitViewReportPrint(requestData)
            .subscribe((printeresp: any) => {
              if (printeresp.statusCode === 200) {
                const successMsg = this.resourceService.get('msg_prnt_succ');
                this.alertService.clearAll().success(successMsg);
                modalRef.hide();
              } else {
                this.alertService.clearAll().error(this.resourceService
                  .translateServerResponse(printeresp.statusMessage));
              }
            }, (err) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
            });
        });
    } else {
      this.printReportSubscribtion = modalRef.content.printReportReceiveEvent()
        .subscribe((requestData: any) => {
          requestData.forEach(request => {
            request['privilege'] = privilege;
          });
          this.submitPrintReportforKitting(requestData)
            .subscribe((printeresp: any) => {
              if (printeresp.statusCode === 200) {
                const successMsg = this.resourceService.get('msg_prnt_succ');
                this.alertService.clearAll().success(successMsg);
                modalRef.hide();
              } else {
                this.alertService.clearAll().error(this.resourceService.translateServerResponse(printeresp.statusMessage));
              }
            }, (err) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
            });
        });
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/printer.service.ts